import { getDataSimple } from "../helpers/apiHelperV3";
import { urls } from "./urls";
const API_NAVIGATION = urls.data.API_NAVIGATION();

export const fetchNavigationTree = (): any => {
  const url = API_NAVIGATION;
  return getDataSimple(url);
};
